import { render, staticRenderFns } from "./SetField.vue?vue&type=template&id=babbc320"
import script from "./SetField.vue?vue&type=script&lang=js"
export * from "./SetField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports